import { render } from "./HeaderDropdownLocale.vue?vue&type=template&id=02e45208&ts=true"
import script from "./HeaderDropdownLocale.vue?vue&type=script&lang=ts"
export * from "./HeaderDropdownLocale.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__